export default "__VITE_ASSET__CMp5Y_Dr__"